import React from 'react';
import { eCDV3ItemTypes } from '../../ui-toolkit/enums/eCDV3ItemTypes';
import { generateSectionItems } from './generateSectionItems';
import { DeedMortgageRecordingFees } from './Items/DeedMortgageRecordingFees/DeedMortgageRecordingFees';
import IHasItemEventProps from './Items/IHasItemEventProps';
import IItemProps from './Items/IItemProps';
import { ICDV3ViewItem, IRecordingFeeViewItem } from '../../ui-toolkit/cdItems/interfaces/ICDViewItem';
import { eRecordingFees } from '../../ui-toolkit/enums/eRecordingFees';

const isDeed = (item: IRecordingFeeViewItem) =>
  item.type === eCDV3ItemTypes.recording_fee && item.sub_type === eRecordingFees.deed;
const isMortgage = (item: IRecordingFeeViewItem) =>
  item.type === eCDV3ItemTypes.recording_fee && item.sub_type === eRecordingFees.mortgage;

export default function generateTaxesSectionItems(
  items: ICDV3ViewItem[],
  { onChange, onRemove, showSeller, hasEditPermissions }: IItemProps & IHasItemEventProps<ICDV3ViewItem>
) {
  const deedsAndMortgages = items
    ? items.filter((item) => isDeed(item as IRecordingFeeViewItem) || isMortgage(item as IRecordingFeeViewItem))
    : [];
  const restItems = items.filter((item) => !deedsAndMortgages.includes(item));
  return [
    deedsAndMortgages.length > 0 ? (
      <DeedMortgageRecordingFees
        key={deedsAndMortgages.map((item) => item.id).join('-')}
        showSeller={showSeller}
        data={deedsAndMortgages as IRecordingFeeViewItem[]}
        onChange={onChange}
        hasEditPermissions={hasEditPermissions}
      />
    ) : null,
    ...generateSectionItems(restItems, { onChange, onRemove, showSeller, hasEditPermissions }),
  ];
}
